import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["navigation", "sections"]

  toggle() {
    if (this.hasNavigationTarget) {
      this.navigationTarget.classList.toggle("toggled")
    }
  }

  close() {
    if (this.hasNavigationTarget) {
      this.navigationTarget.classList.remove("toggled")
    }
  }

  // Cierra el menú full-screen al tocar un link. El overlay mobile es absolute
  // dentro del header fixed → se comporta como fixed y tapa el contenido, por eso
  // hay que cerrarlo. Para anclas de la misma página (/#planes) hacemos el scroll
  // DESPUÉS de cerrar y con scrollIntoView (respeta scroll-margin-top), así el
  // destino cae en el inicio de la sección y no bajo el nav.
  navigate(event) {
    const link = event.target.closest("a")
    if (!link) return

    const url = new URL(link.href, window.location.href)
    const target =
      url.hash && url.pathname === window.location.pathname
        ? document.getElementById(decodeURIComponent(url.hash.slice(1)))
        : null

    this.close()

    if (target) {
      event.preventDefault()
      // esperar un frame a que el overlay se cierre antes de scrollear
      requestAnimationFrame(() => {
        target.scrollIntoView({ behavior: "smooth" })
        history.replaceState(null, "", url.hash)
      })
    }
  }
}
